import { Outlet } from "react-router-dom";
import { useMaterialUIController } from "../../context/contexts";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Sidenav from "../../examples/Sidenav";
import GeneralDashboardLayout from "./components/GeneralDashboardLayout";

// Images
import brandWhite from "../../assets/images/logo.png";
import brandDark from "../../assets/images/logo.png";
import navRoutes from "./components/navRoutes";
import { properlizeWords } from "../../helpers";

const WorkerDahboardLayouyt = () => {

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;


    return (
        <GeneralDashboardLayout>
            <DashboardNavbar />
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName={process.env.REACT_APP_APP_NAME ?? ""}
              routes={navRoutes}
            //   onMouseEnter={handleOnMouseEnter}
            //   onMouseLeave={handleOnMouseLeave}
            />
            <Outlet />
        </GeneralDashboardLayout>
    );
}
 
export default WorkerDahboardLayouyt;